module.exports = __webpack_public_path__ + "img/banner-10372dc9.png";